/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Field_Extraction_StatusInputs */

const en_inbound_field_extraction_status = /** @type {(inputs: Inbound_Field_Extraction_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading of the packing list`)
};

/**
* | output |
* | --- |
* | "Reading of the packing list" |
*
* @param {Inbound_Field_Extraction_StatusInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_field_extraction_status = /** @type {((inputs?: Inbound_Field_Extraction_StatusInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Field_Extraction_StatusInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_field_extraction_status(inputs)
});